var React = require('react');

function DropFile (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13 24H36.5M13 32.5H36.5M13 41H36.5","stroke":"currentColor","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M15.9983 59H4C2.89543 59 2 58.1046 2 57V4C2 2.89543 2.89543 2 4 2H33.6899C34.2197 2 34.7278 2.21022 35.1028 2.5845L47.4129 14.8723C47.7888 15.2475 48 15.7568 48 16.2878V57C48 58.1046 47.1046 59 46 59H34.5172","stroke":"currentColor","strokeWidth":"3","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M25.5 75.1667V52.8333M25.5 75.1667L17.0417 66.7083M25.5 75.1667L33.9583 66.7083","stroke":"currentColor","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

DropFile.defaultProps = {"width":"50","height":"80","viewBox":"0 0 50 80","fill":"none"};

module.exports = DropFile;

DropFile.default = DropFile;
